import {
  EventScheduleFilterItemWrapper,
  EventScheduleFilterList,
} from "../../../../EventSchedule/components/filter/style";
import { Cafe } from "../../../../../../api/types";

export interface EventScheduleFilterProps {
  open: boolean;
  setOpen: (v: boolean) => void;
  filterList: Cafe[];
  label: string;
  selectedItem: Cafe | null;
  setSelectedItem: (v: Cafe) => void;
}

const PubFilter = ({
  open,
  setOpen,
  filterList,
  label,
  selectedItem,
  setSelectedItem,
}: EventScheduleFilterProps) => {
  const getPubName = (value: string) => {
    if (value.includes("러너펍")) {
      return value.replace("러너펍", "").trim();
    } else if (value.includes("러너라운지")) {
      const naem = value.replace("러너라운지", "").trim().replace("점", "");
      return `${naem}라운지`;
    }
    return value;
  };
  return (
    <EventScheduleFilterItemWrapper
      onClick={() => {
        setOpen(!open);
      }}
    >
      {selectedItem ? getPubName(selectedItem.cafeName) : label}
      <img src="/image-web/rank/down-arrow.svg" alt="down" />
      {open && (
        <EventScheduleFilterList>
          {filterList.map((item, index) => (
            <div
              className={`item ${selectedItem?.id === item.id ? "select" : ""}`}
              key={index}
              onClick={() => {
                setSelectedItem(item);
              }}
            >
              {item.id === -1 ? label : getPubName(item.cafeName)}
            </div>
          ))}
        </EventScheduleFilterList>
      )}
    </EventScheduleFilterItemWrapper>
  );
};

export default PubFilter;
